import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store'
import App from './App.js'
import ResidentPage from './pages/resident/index'
import HomePage from './pages/home/index'
import GuestPage from './pages/guest/index'
import ScanPage from './pages/scan/index'
import SettingsPage from './pages/settings/index'
import 'typeface-roboto'
import './index.css'
const target = document.querySelector('#root')

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" exact render={() => (<App><HomePage /></App>)} />
        <Route path="/resident" render={() => (<App><ResidentPage /></App>)} />
        <Route path="/scan" exact render={() => (<App><ScanPage /></App>)} />
        <Route path="/guest" exact render={() => (<App><GuestPage /></App>)} />
        <Route path="/guest/:guest_id" exact render={() => (<App><GuestPage /></App>)} />
        <Route path="/settings" exact render={() => (<App><SettingsPage /></App>)} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  target
)


// WEBPACK FOOTER //
// ./src/index.js